import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  tinitial () {
    return require('static/tinitial.json')
  },
  tfolder () {
    return {
      'total': '46',
      'rows': [
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRAL51E',
          'folder': 'Leave_Application'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRAP31E',
          'folder': 'Appraisal_Doc'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRBF16E',
          'folder': 'Details_Of_Med.Requisition'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRBF31E',
          'folder': 'Insurance_Policy'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRBF43E',
          'folder': 'Benefits_Information'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRBF5IX',
          'folder': 'Loan_Interest_Certificate'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRCO01E',
          'folder': 'Company_Map'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRCO01E1',
          'folder': 'Company_sign'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRCO2JE',
          'folder': 'Test_content'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES32E',
          'folder': 'Change_Personal_Data'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES3BE',
          'folder': 'Employee_Complaint'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES52E1',
          'folder': 'Pollh'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES52E2',
          'folder': 'Polld'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES62E',
          'folder': 'Leave_Application'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES6IE',
          'folder': 'Training_Request'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES71E',
          'folder': 'Medical_Request'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES74E',
          'folder': 'BF_Requisition'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRES81E',
          'folder': 'Travel_Request'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRMS62E',
          'folder': 'Leave_Application'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HROF0CE',
          'folder': 'Customer_Document'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPM1EE',
          'folder': 'Company_Assets'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPM33R',
          'folder': 'Probation_Result_Mail_Merge'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPM55R',
          'folder': 'Mail_Merge'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPM5CE',
          'folder': 'Change_Of_Collateral'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPMC2E',
          'folder': 'Employee_Data'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPMC2E1',
          'folder': 'Employee_img'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPOLLD',
          'folder': 'Polld'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPOLLH',
          'folder': 'Pollh'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRPY54R',
          'folder': 'Print_Notice_To_Bank'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC1GE',
          'folder': 'Test_content'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC21E',
          'folder': 'Employee_Data'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC21E_',
          'folder': 'Application'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC35X',
          'folder': 'Print_letter_of_application'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC36X',
          'folder': 'Print_Issued_Letter'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC37X',
          'folder': 'Print_Invitation_Letter'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC49X',
          'folder': 'Print_Employment_Contract'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRRC52E',
          'folder': 'Collateral_information'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR11E1',
          'folder': 'Course_Information'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR11E2',
          'folder': 'E-learning'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR21E',
          'folder': 'Lecturer_Detail'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR4CR',
          'folder': 'Print_Tr.Admission_Letter'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR4FE',
          'folder': 'External_Training'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR55E',
          'folder': 'Internal_Training'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR63E',
          'folder': 'After_Class_information'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR67X',
          'folder': 'Training_Certificate'
        },
        {
          'coderror': '200',
          'desc_coderror': ' ',
          'total': '46',
          'main': '\\\\192.168.2.18\\document\\',
          'temp': '\\\\192.168.2.18\\temp\\',
          'load': 'https://192.168.2.81:8443/file_uploads/',
          'codapp': 'HRTR7AE',
          'folder': 'Training_Information'
        }
      ]
    }
  },
  modules () {
    return require('static/module_permis.json')
  },
  headerNotiTotal () {
    const mockArrCodapp = [ 'hres33u', 'hres35u', 'hres37u', 'hres3cu', 'hres63u', 'hres6nu', 'hres6bu', 'hres6eu', 'hres6lu', 'hres96u', 'hres72u', 'hres75u', 'hres78u', 'hres85u', 'hres87u', 'hress3u', 'hres89u', 'hress5u', 'hres6ju', 'hres92u', 'hres94u' ]
    const mockArrOption1 = [ 'user', 'sitemap', 'file-text-o', 'bullhorn', 'envelope', 'envelope', 'clock-o', 'clock-o', 'clock-o', 'calendar', 'ambulance', 'briefcase', 'btc', 'car', 'envelope', 'btc', 'user-plus', 'user-plus', 'book', 'book', 'book' ]
    const mockArrOption2 = [ 'red', 'purple', 'maroon', 'olive', 'orange', 'blue' ]
    let mockRequest = []
    let totalRequest = 0
    const requestAmount = Math.floor((Math.random() * 20))
    for (var j = 0; j < requestAmount; j++) {
      mockRequest.push({
        key: mockArrCodapp[Math.floor(Math.random() * mockArrCodapp.length)],
        option1: 'fa-' + mockArrOption1[Math.floor(Math.random() * mockArrOption1.length)],
        option2: 'bg-' + mockArrOption2[Math.floor(Math.random() * mockArrOption2.length)],
        values: faker.lorem.sentence().substring(1, 20),
        summary: Math.floor((Math.random() * 100))
      })
      totalRequest += mockRequest[j]['summary']
    }
    return {
      announce: Math.floor(Math.random() * 101) + 10,
      request: Math.floor(Math.random() * 101) + 10,
      approve: {
        total: totalRequest,
        rows: mockRequest
      }
    }
  },
  headerNotiAnnounceTotal () {
    return Math.floor(Math.random() * 101) + 10
  },
  headerNotiAnnounce () {
    let mockAnnounces = []
    const announceAmount = 10
    for (var i = 0; i < announceAmount; i++) {
      mockAnnounces.push({
        codempid: faker.lorem.word(),
        descCodempid: faker.lorem.sentence()
      })
    }
    return {
      total: announceAmount,
      rows: mockAnnounces
    }
  },
  headerNotiRequestTotal () {
    return Math.floor(Math.random() * 101) + 10
  },
  headerNotiRequest () {
    let mockNotis = []
    const notiAmount = 10
    const mockStaappr = [ 'P', 'Y', 'N', 'A' ]
    const mockArrCodapp = [ 'hres34e', 'hres62e', 'hres36e', 'hres6ae' ]
    for (var j = 0; j < notiAmount; j++) {
      mockNotis.push({
        codapp: mockArrCodapp[Math.floor(Math.random() * mockArrCodapp.length)],
        desccodapp: faker.lorem.sentence(),
        descapp: faker.lorem.sentence(),
        staappr: mockStaappr[Math.floor((Math.random() * 3))],
        detail1: faker.lorem.sentence(),
        detail2: faker.lorem.sentence(),
        dtereq: faker.date.past().toString().substr(4, 12)
      })
    }
    return {
      total: notiAmount,
      rows: mockNotis
    }
  },
  headerNotiApprove () {
    const mockArrCodapp = [ 'hres33u', 'hres35u', 'hres37u', 'hres3cu', 'hres63u', 'hres6nu', 'hres6bu', 'hres6eu', 'hres6lu', 'hres96u', 'hres72u', 'hres75u', 'hres78u', 'hres85u', 'hres87u', 'hress3u', 'hres89u', 'hress5u', 'hres6ju', 'hres92u', 'hres94u' ]
    const mockArrOption1 = [ 'user', 'sitemap', 'file-text-o', 'bullhorn', 'envelope', 'envelope', 'clock-o', 'clock-o', 'clock-o', 'calendar', 'ambulance', 'briefcase', 'btc', 'car', 'envelope', 'btc', 'user-plus', 'user-plus', 'book', 'book', 'book' ]
    const mockArrOption2 = [ 'red', 'purple', 'maroon', 'olive', 'orange', 'blue' ]
    let mockRequest = []
    let totalRequest = 0
    const requestAmount = Math.floor((Math.random() * 20))
    for (var j = 0; j < requestAmount; j++) {
      mockRequest.push({
        key: mockArrCodapp[Math.floor(Math.random() * mockArrCodapp.length)],
        option1: 'fa-' + mockArrOption1[Math.floor(Math.random() * mockArrOption1.length)],
        option2: 'bg-' + mockArrOption2[Math.floor(Math.random() * mockArrOption2.length)],
        values: faker.lorem.sentence().substring(1, 20),
        summary: Math.floor((Math.random() * 100))
      })
      totalRequest += mockRequest[j]['summary']
    }
    return {
      total: totalRequest,
      rows: mockRequest
    }
  },
  getMailLang () {
    return {
      maillang: 'en'
    }
  },
  postMailLang () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/dash/mocker.js